<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'AllDicts' }" id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к справочникам
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<div class="name">
							<h3 class="title">Редактирование справочника Районов:</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn">
								<div class="md-layout">
									<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right">
										<router-link :to="{ name: 'districtItemData', params: {id: 'new', dictCode: dictId, page: filterData.page}}"
													 class="md-primary"
													 tag="md-button">
											Добавить новый элемент
										</router-link>
									</div>
								</div>
								<md-card class="md-card-plain">
									<md-card-content>
										<md-table class="table-shopping"
                                                  v-model="dictionaryListData"
                                                  md-sort="id"
                                                  md-sort-order="asc"
                                        >
											<md-table-row slot="md-table-row" slot-scope="{ item }">
												<md-table-cell md-label="Id элемента"
                                                               md-sort-by="id"
                                                >
													<router-link
															:to="{ name: 'districtItemData', params: { id: item.id } }">
														{{ item.id }}
													</router-link>
												</md-table-cell>
												<md-table-cell md-label="Район">
													<router-link
															:to="{ name: 'districtItemData', params: { id: item.id } }">
														{{ item.name }}
													</router-link>
												</md-table-cell>
												<md-table-cell md-label="Город(locId)">
													<router-link
															:to="{ name: 'districtItemData', params: { id: item.id } }">
														{{ item.locId }}
													</router-link>
												</md-table-cell>
												<md-table-cell>
													<router-link
															:to="{ name: 'districtItemData', params: {id: item.id, dictCode: item.dictCode, action: 'delete'} }"
															event="" @click.native.prevent="confirmDelete({ name: 'districtItemData', params: {id: item.id, dictCode: item.dictCode, action: 'delete'} })"
													>
														<md-icon>delete</md-icon>
													</router-link>
												</md-table-cell>
											</md-table-row>
										</md-table>
									</md-card-content>
								</md-card>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import { getItem } from '@/utils/dict-api'

    export default {
        mixins: [],
        props: ['dictionaryId', 'page'],
        bodyClass: 'dictionary-list',
        data () {
            return {
                options: [],
                dictId: this.$route.params.dictCode,
                dictionaryListData: [],
                filterData: {
                    page: this.page || 1,
                },
            }
        },
        methods: {
            getDistrict () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('district').then(result => {
                        this.dictionaryListData = result
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
			confirmDelete (route) {
				if (confirm("Действительно удалить?")) {
					this.$router.push(route);
				}
			}
        },
        created () {
            this.getDistrict()
        },
    }
</script>
<style lang="scss" scoped type="text/scss">
	.savebtn {
		margin-right: 0px;
		padding-right: 5px;
	}

</style>
